var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_248009",
    "data-name": "Path 248009",
    d: "M11.8,10.35,7.3,6.633a.5.5,0,0,0-.525-.057A.552.552,0,0,0,6.5,7.09V8.806H6.25C2.8,8.806,0,12.008,0,15.954a.541.541,0,0,0,.375.543.242.242,0,0,0,.125.029.458.458,0,0,0,.425-.286l.325-.572a5.149,5.149,0,0,1,4.475-2.859H6.5v1.716a.584.584,0,0,0,.275.515.447.447,0,0,0,.525-.057l4.5-3.717a.623.623,0,0,0,0-.915Z",
    transform: "translate(0 -6.526)",
    fill: "#07b4e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dcfe26f38fff444d0e162a29721b68d4.svg";
export { ForwardRef as ReactComponent };